import React from 'react';
import { PeopleIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipState = {
  Active: 'success',
  Draft: 'default',
  Canceled: 'error',
};

function renderItem(account, t): Nullable<SearchItemViewModel> {
  return {
    title: account['Name'],
    descriptionFields: [
      {
        type: 'Text',
        value: account['AccountNumber'],
        title: account['AccountNumber'],
      },
      {
        type: 'Currency',
        value: account['Balance'],
        title: t('Account.Balance'),
        currency: account['Currency.Code'],
      },
    ],
    chipField: {
      state: chipState[account['Status']],
      label: t(`Account.Status.${account['Status']}`),
    },
    href: convertToBillingUrl(
      `/apps/CustomerAccount.do?method=view&id=${account.Id}`,
    ),
  };
}

export const Account: SearchMeta = {
  objectType: 'Account',
  objectLabelI18n: 'Account.TabLabel',
  tabIcon: <PeopleIcon />,
  needsPermission: false,
  listPageUrl: convertToBillingUrl('/apps/CustomerAccount.do'),
  hasAdvancedSearch: true,
  renderItem,
};
